import { useFetch } from '@vueuse/core';

export function useFonts() {
    async function fetchGoogleFonts(apiKey: string) {
        return await useFetch(`https://www.googleapis.com/webfonts/v1/webfonts?key=${apiKey}&sort=popularity`)
            .get()
            .json();
    }

    return {
        fetchGoogleFonts
    };
}
